import SpeedingFeature from "@/services/maps/features/reports/speeding.feature";
import DateUtil from "@/utils/date.util";
import DeviceUtil from "@/utils/device.util";
import { Feature } from "ol";
import { Geometry } from "ol/geom";
import ReportStrategy from "./report.strategy";

export default class SpeedReportStrategy extends ReportStrategy {

    async getExtraFeatures(): Promise<Feature<Geometry>[]> {
        return this.getSpeedingFeatures()
    }

    async getSpeedingFeatures() {
        const speedLimit = DeviceUtil.formatKnToKmh(Number(this.device?.attributes?.speedLimit || 0))
        const speeding = this.data.filter(position => DeviceUtil.formatKnToKmh(position.speed) > speedLimit)
        return speeding.map((position, index) => {
            return new SpeedingFeature({
                date: DateUtil.getGenericFormat(position.deviceTime),
                index: index + 1,
                latitude: position.latitude,
                longitude: position.longitude,
                report: this.report,
                title: 'EXCESO DE VELOCIDAD ' + (index + 1),
                speed: DeviceUtil.formatKnToKmh(position.speed).toString() + 'Km/h',
                speedLimit: speedLimit.toFixed(0) + 'Km/h',
            }).create()
        })
    }

}